import { render, staticRenderFns } from "./deliveryAddress.vue?vue&type=template&id=3fbea455&scoped=true"
import script from "./deliveryAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./deliveryAddress.vue?vue&type=script&setup=true&lang=js"
import style0 from "./deliveryAddress.vue?vue&type=style&index=0&id=3fbea455&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbea455",
  null
  
)

export default component.exports